<template>
    <span v-show="false"></span>
</template>
<script>
import store from '../store'
import { map, uniqBy } from 'lodash'

export default {
  name: 'InitialData',
  data () {
    return { ...window.vueData.initialData }
  },
  computed: {
    getDataKeyActionSetupLookup () {
      return {
        allAttributes: 'setAllAttributes',
        cartData: 'setCartData',
        productBadges: 'setProductBadges',
        config: 'setConfig',
        products: 'setLiveProducts',
        selectedProductCodeId: 'setSelectedProductCodeId',
        previewOrder: 'setPreviewOrderData',
        uriWithoutOffset: 'setUriWithoutOffset',
        isTopLevelCategory: 'setIsTopLevelCategory',
        productCategoryData: 'setProductCategoryData',
        mapPoints: 'setMapPoints',
        // Variations
        allVariations: 'setAllVariations',
        relatedVariationData: 'setRelatedVariationData',
        variationsActive: 'setVariationsActive',
        variationFilterQueryStringVar: 'setVariationFilterQueryStringVar',
        activeVariationFilters: 'setActiveVariationFilters',
        variationRecordsUsed: 'setVariationRecordsUsed',
        productVariationInfoData: 'setProductVariationInfoData',
        selectedCurrency: 'setSelectedCurrency'
      }
    }
  },
  mounted () {
    for (const [dataKey, actionSetup] of Object.entries(this.getDataKeyActionSetupLookup)) {
      if (!(dataKey in this)) {
        continue
      }
      this.$store.dispatch(actionSetup, this[dataKey])
    }

    if (this.hasOwnProperty('listingVariationGroupCombos')) {
      const listingVariationGroupCombosUnique = map(this.listingVariationGroupCombos, (combo) => {
        combo.variations = uniqBy(combo.variations, 'variationId').sort((a, b) =>
          parseInt(a.variationOrder) -
          parseInt(b.variationOrder))
        combo.variationGroupStep = Number(combo.variationGroupStep)
        return combo
      })
      listingVariationGroupCombosUnique.sort((a, b) => parseInt(a.variationGroupOrder) -
        parseInt(b.variationGroupOrder))
      store.dispatch('setListingVariationGroupCombos', listingVariationGroupCombosUnique)
    }
  },
  methods: {
    checkConnectionStatus () {
      this.$store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  }
}
</script>
